import type { Release } from '../releases';

export default {
  id: '2026-11-02-report-pilot-first',
  at: '2026-11-03T05:02:00Z',
  title: '«Сообщить» → «Нужна помощь»: сначала ответ Pilot',
  modules: [],
  items: [
    'Если в портале подключён Pilot, в «Сообщить» → «Нужна помощь» под вопросом появилась кнопка «Сначала спросить Pilot». Он отвечает по инструкции к странице и статьям базы знаний, которые вам открыты, со ссылками на них.',
    'Ответ помог — нажмите «Помогло», вопрос закроется без специалиста. Не помог — отправьте вопрос как обычно: специалист увидит и вопрос, и ответ Pilot.',
  ],
  why: 'На простые вопросы о том, как работать в портале, приходилось ждать специалиста до нескольких часов, хотя ответ уже есть в инструкциях.',
  link: '/support',
} satisfies Release;
